mutation SendPreviewLinks($campaignId: ID!, $emailAddresses: [String]!, $previewUrl: String!) {
    sendPreviewLinks(campaignId: $campaignId, emailAddresses: $emailAddresses, previewUrl: $previewUrl) {
        ok
    }
}
